import type { PropsWithChildren } from "react";

type AlertVariant = "info" | "success" | "warning" | "danger";

export function Alert({ variant = "info", children }: PropsWithChildren<{ variant?: AlertVariant }>) {
  return (
    <div className={`alert alert-${variant}`} role={variant === "danger" ? "alert" : "status"} aria-live={variant === "danger" ? "assertive" : "polite"}>
      {children}
    </div>
  );
}

